import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { t } from "i18next";
import userService from "../../services/userService";

export const ForgotPassword = () => {
    const { t, i18n } = useTranslation();
    const [ePosta, ePostaUpdate] = useState('');
    const adreseGit = useNavigate();

    const changeLang = async (lang) => {
        await i18n.changeLanguage(lang);
        localStorage.setItem('siteLang', lang);
    }

    useEffect(() => {
        sessionStorage.clear();
    }, []);

    const validate = () => {
        let result = true;
        if (ePosta === '' || ePosta === null) {
            result = false;
            toast.warning(t('mesajEpostaEksik'));
        }

        return result
    }

    const ProceedLogin = async (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                const resp = await userService.forgotPassword(ePosta);
                if (resp == "OK") {
                    toast.success(t('mesajSifremiUnuttumMail'))
                    adreseGit('/login')
                } else {
                    toast.warning(resp)
                }
            } catch (err) {
                toast.error(t('mesajSunucuTarafiHatasi') + (err.message || ""));
            }
        }
    }

    const labelStyle = {
        fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
        letterSpacing: '0.5px', color: '#64748b', marginBottom: '6px', display: 'block',
    };

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg, #1e2a38 0%, #2563a8 100%)',
            padding: '24px',
        }}>
            <div style={{
                display: 'flex', width: '100%', maxWidth: '720px',
                borderRadius: '20px', overflow: 'hidden',
                boxShadow: '0 24px 60px rgba(0,0,0,0.35)',
            }}>
                {/* ── Sol Panel ── */}
                <div style={{
                    flex: 1, padding: '48px 36px', display: 'flex', flexDirection: 'column',
                    justifyContent: 'space-between', background: 'rgba(255,255,255,0.06)',
                    borderRight: '1px solid rgba(255,255,255,0.08)',
                }}>
                    <div>
                        <div style={{
                            background: '#fff', borderRadius: '14px', padding: '12px 16px',
                            display: 'inline-flex', marginBottom: '28px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        }}>
                            <img src="kama-3d-logo.png" alt="Kama 3D" style={{ width: 100 }} />
                        </div>
                        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 10 }}>
                            {t('baslikSifremiUnuttum')}
                        </h5>
                        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', lineHeight: 1.7, margin: 0 }}>
                            {i18n.language.startsWith('tr')
                                ? 'E-posta adresinizi girin, şifre sıfırlama bağlantısını size gönderelim.'
                                : 'Enter your e-mail address and we will send you a password reset link.'}
                        </p>
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.25)', fontSize: '12px' }}>
                        © {new Date().getFullYear()} Kama 3D Doküman Merkezi
                    </div>
                </div>

                {/* ── Sağ Panel ── */}
                <div style={{ width: '320px', background: '#fff', padding: '48px 36px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px' }}>
                        <h5 style={{ fontWeight: 700, color: '#1e293b', margin: 0 }}>{t('baslikSifremiUnuttum')}</h5>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <img src="flag-tr.png" alt="TR" onClick={() => changeLang('tr')}
                                style={{ width: 24, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('tr') ? 1 : 0.3, transition: 'opacity 0.2s' }} />
                            <img src="flag-en.png" alt="EN" onClick={() => changeLang('en')}
                                style={{ width: 24, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('en') ? 1 : 0.3, transition: 'opacity 0.2s' }} />
                        </div>
                    </div>

                    <form onSubmit={ProceedLogin}>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={labelStyle}>{t('formUyelikEposta')}</label>
                            <input
                                value={ePosta}
                                onChange={e => ePostaUpdate(e.target.value)}
                                className="form-control"
                                type="text"
                                placeholder="ornek@kama.com.tr"
                            />
                        </div>

                        <button type="submit" className="btn btn-primary w-100 py-2 fw-bold mb-3">
                            {t('butonDevam')}
                        </button>
                        <Link to={'/login'} className="btn btn-outline-secondary w-100 py-2 fw-bold">
                            {t('butonGeri')}
                        </Link>
                    </form>
                </div>
            </div>
        </div>
    )
}
